export const psAgreementEmbeddableTemplateDef: {
  [key: string]: {
    colName: string
    modelName: string
    example: string
  }
} = {
  医院_医院名: {
    colName: 'name',
    modelName: 'ps_clinics',
    example: 'ABCクリニック',
  },
  医院_院長名: {
    colName: 'doctor_leader_name',
    modelName: 'ps_clinics',
    example: '山田太郎',
  },
  医院_住所: {
    colName: 'address',
    modelName: 'ps_clinics',
    example: '東京都千代田区永田町1-7-1',
  },
  医院_電話番号: {
    colName: 'phone',
    modelName: 'ps_clinics',
    example: '03-1234-5678',
  },
  医院_メールアドレス: {
    colName: 'email',
    modelName: 'ps_clinics',
    example: 'abc@example.com',
  },
  医院_ウェブサイト: {
    colName: 'website',
    modelName: 'ps_clinics',
    example: 'https://www.example.com',
  },
  医院_営業時間: {
    colName: 'business_hours',
    modelName: 'ps_clinics',
    example: '9:00-18:00',
  },
  医院_入院時の対応時間と体制: {
    colName: 'hospital_admission_desc',
    modelName: 'ps_clinics',
    example: '',
  },
  飼い主様_お名前: {
    colName: 'owner_name',
    modelName: 'ps_agreement_requests',
    example: '鈴木花子',
  },
  飼い主様_メールアドレス: {
    colName: 'owner_email',
    modelName: 'ps_agreement_requests',
    example: 'taro@example.com',
  },
  ペット_お名前: {
    colName: 'pet_name',
    modelName: 'ps_agreement_requests',
    example: 'ポチ',
  },
  ペット_種別: {
    colName: 'pet_type',
    modelName: 'ps_agreement_requests',
    example: '犬',
  },
  ペット_性別: {
    colName: 'pet_gender',
    modelName: 'ps_agreement_requests',
    example: 'オス',
  },
  ペット_生年月日: {
    colName: 'pet_birthday',
    modelName: 'ps_agreement_requests',
    example: '2024-10-20',
  },
  ペット_年齢: {
    colName: 'pet_age',
    modelName: 'ps_agreement_requests',
    example: '2歳 9ヶ月',
  },
}

export const parsePsAgreementEmbeddableValue = (records: {
  ps_clinics: Record<string, any>
  ps_agreement_requests: Record<string, any>
}) => {
  return Object.keys(psAgreementEmbeddableTemplateDef).reduce((acc, key) => {
    const modelName = psAgreementEmbeddableTemplateDef[key]?.modelName
    const colName = psAgreementEmbeddableTemplateDef[key]?.colName
    if (modelName && colName) {
      acc[key] = records[modelName][colName] || ''
    }
    return acc
  }, {})
}
